export default "__VITE_ASSET__3ddccfd1__"